<template>
  <div>
    <livePlayer
        ref="livePlayer"
        :options="options"
        :source="source"
    />
  </div>

</template>

<script>
import VuePlayer from "vue-aliplayer-v2";

export default {
  name: "mediaPlayer",
  components: { "livePlayer": VuePlayer },
  props: {
    sourceUrl:{
      type: String,
      default: ''
    },
  },
  data() {
    return {
      source: "",
      options:{
        // liveStartTime: "2022/04/21 14:50:00", //直播开始时间，直播时移功能使用，格式为：“2018/01/04 12:00:00”。
        // liveOverTime: "2022/04/21 15:00:00", //直播结束时间，直播时移功能使用，格式为：“2018/01/04 12:00:00”。
        // liveTimeShiftUrl: "", //直播可用时移查询地址，详情参见直播时移。
        width:"100%",
        height:"100%",
        useH5Prism:true, //启用H5播放模式
        diagnosisButtonVisible: false, //是否显示检测按钮，默认为true。
        controlBarVisibility: "click",
        showBarTime: "4000",
        language: "zh-cn",
        playsinline: true,
        autoplay: false,
        isLive: true,
        format: 'm3u8',

        hlsFrameChasing: true,
        x5_fullscreen: true,
        x5_orientation: 'landscape',
        useHlsPluginForSafari: true,

        waitingTimeout: 60, //最大缓冲超时时间，超过这个时间会有错误提示，默认：60秒。
        // liveRetry: 100,
        cover: require("../../assets/live/live20220519_foreshow.jpg"),
        // source: "//ivi.bupt.edu.cn/hls/cctv1.m3u8",
        // source: "//player.alicdn.com/video/aliyunmedia.mp4",
        skinLayout:[
          {name: "bigPlayButton", align: "cc", x: 30, y: 80},
          {
            name: "H5Loading", align: "cc"
          },
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay"},
          {name: "tooltip", align:"blabs",x: 0, y: 56},
          {name: "thumbnail"},
          {
            name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              {name: "progress", align: "blabs", x: 0, y: 44},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name: "liveDisplay", align: "tl", x: 15, y:12},
              {name: "timeDisplay", align: "tl", x: 10, y: 7},
              {name: "fullScreenButton", align: "tr", x: 10, y: 12},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              {name: "volume", align: "tr", x: 5, y: 10}
            ]
          }
        ],
      },
    };
  },
  methods: {
    resetLiveSourceUrl(url, isLive){
      this.options.isLive = isLive
      console.log('media player url: '+url)
      if(url.length<5){
        console.log("media player url:<5")
        this.source = ""
      }else{
        console.log("media player url: ok")
        this.source = url
      }

    },
    play() {
      this.$refs.livePlayer.play();
    },
    pause() {
      this.$refs.livePlayer.pause();
    },
    replay() {
      this.$refs.livePlayer.replay();
    },
    getCurrentTime() {
      console.log("getCurrentTime:"+this.$refs.livePlayer.getCurrentTime())
      // this.$refs.livePlayer.getCurrentTime();
      return this.$refs.livePlayer.getCurrentTime()
    },

    getStatus() {
      const status = this.$refs.livePlayer.getStatus();
      console.log(`getStatus:`, status);
      // alert(`getStatus:${status}`);
      return status
    },
  }
}
</script>

<style scoped>

</style>